import { Form, Input, Radio, RadioChangeEvent, Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';

interface ShipmentMethod {
  shipmentMethod: string;
  statusBox?: Boolean;
  method?: string;
  handleChange?: any;
  detail?: any;
  onChangeRadio?: any;
  shipmenDetail?: string;
}
function ShipmentMethod({
  shipmentMethod,
  statusBox,
  method,
  handleChange,
  detail,
  onChangeRadio,
  shipmenDetail
}: ShipmentMethod) {
  const [value, setValue] = useState(1);
  const { Text } = Typography;
  const [form] = Form.useForm();

  const onChangeRadioDif = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  return (
    <>
      {statusBox ? (
        <Form
          layout="vertical"
          style={{ width: '100%', height: '130px' }}
          form={form}
        >
          <div className="shipmentMethod" style={{ height: '100%' }}>
            <p>Shipment Method</p>
            <Radio.Group onChange={onChangeRadio} value={shipmentMethod}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Radio value="AIR">Air | Carrier</Radio>
                <Form.Item name="detail" rules={[{ required: true }]}>
                  <Text keyboard style={{ display: 'none' }}></Text>
                  <Input value={detail} onChange={handleChange} />
                </Form.Item>
              </div>
              <Radio value="OCEAN">Ocean</Radio>
            </Radio.Group>
          </div>
        </Form>
      ) : (
        <Form layout="vertical" style={{ width: '100%', height: '130px' }}>
          <div className="shipmentMethod" style={{ height: '100%' }}>
            <p>Shipment Method</p>
            <Radio.Group
              onChange={onChangeRadioDif}
              value={shipmentMethod}
              disabled
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Radio value="AIR">Air | Carrier</Radio>
                <Form.Item name="year" rules={[{ required: true }]}>
                  <Text keyboard disabled>
                    {shipmenDetail}
                  </Text>
                </Form.Item>
              </div>
              <Radio value="Ocean">Ocean </Radio>
            </Radio.Group>
          </div>
        </Form>
      )}
    </>
  );
}

export default ShipmentMethod;
